import React from "react";
import {
  HeroFormBackground,
  HeroFormBase,
  HeroText,
  Title,
  Subtitle,
  StyledQuickFacts,
  Form,
  FormTitle,
  FormSubtitle,
} from "./hero-form.styled";
import { HeroFormSliceFragment } from "../../types/graphql";
import HubSpotForm from "../hubspot-form/hubspot-form";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import Breadcrumbs, { BreadCrumbProps } from "../breadcrumbs/breadcrumbs";

interface IHeroFormProps {
  hero: HeroFormSliceFragment;
  breadcrumbs?: BreadCrumbProps[];
}

const HeroForm = ({ hero, breadcrumbs }: IHeroFormProps) => {
  return (
    (hero.primary && (
      <HeroFormBackground>
        <HeroFormBase doubleColumn={!hero.primary.single_column}>
          {breadcrumbs && breadcrumbs.length > 0 && (
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          )}
          <HeroText doubleColumn={!hero.primary.single_column}>
            {hero.primary.title && <Title>{hero.primary.title}</Title>}
            {hero.primary.subtitle && (
              <Subtitle>
                <PrismicRichText
                  field={hero.primary.subtitle.richText}
                  components={htmlSerializer}
                />
              </Subtitle>
            )}
            {hero.items && hero.items.length > 0 && (
              <StyledQuickFacts
                quickFacts={hero.items}
                doubleColumn={!hero.primary.single_column}
              />
            )}
          </HeroText>
          <Form doubleColumn={!hero.primary.single_column}>
            {hero.primary.form_title && (
              <FormTitle>{hero.primary.form_title}</FormTitle>
            )}
            {hero.primary.form_subtitle && (
              <FormSubtitle>
                <PrismicRichText
                  field={hero.primary.form_subtitle.richText}
                  components={htmlSerializer}
                />
              </FormSubtitle>
            )}
            {hero.primary?.hubspot_form_id && (
              <HubSpotForm hubSpotFormID={hero.primary?.hubspot_form_id} />
            )}
          </Form>
        </HeroFormBase>
      </HeroFormBackground>
    )) || <></>
  );
};

export default HeroForm;
